type ApproachConstantsProps = {
  header: string;
  designProcessSubheader: string;
  designProcessDescription: string;
  sustainablePrinciplesSubheader: string;
  sustainablePrinciplesDescription: string;
};

const APPROACH_CONSTANTS: ApproachConstantsProps = {
  header: "Our Approach",
  designProcessSubheader: "Design Process",
  designProcessDescription:
    "Our approach to design is one of collaboration. We feel strongly that stakeholders of the project are involved in all major decisions throughout the project. We bring management, staff, representatives, community members and other invited parties together to analyze and develop concepts and implementation plans. The process and techniques that we employ keep members aware of the overall implications of their decisions and will maintain the team effort required for a successful project.",
  sustainablePrinciplesSubheader: "Sustainable Principles",
  sustainablePrinciplesDescription:
    "As an integral part of our design philosophy, we consider a project's impacts on the land and the health and wellbeing of building users.",
};

export default APPROACH_CONSTANTS;
